module.exports = __webpack_public_path__ + "img/Xgrow-2-en.8293e412.png";